import React, { useState, useEffect } from "react";
import "./commission-configuration.scss";
import CreateCommission from "./CreateCommission";
import UpdateCommissionConModal from "./UpdateCommission";
import { getAllCommissionConfigurations, deleteCommissionConfig } from "../../../../requests/comissionApi";
import moment from "moment/moment";
import { toast } from "react-toastify";

const CommissionConfigurationSection = () => {
  const [rows, setRows] = useState([]);
  const [selectedCommission, setSelectedCommission] = useState(null);
  const allChecked = rows.every((row) => row.selected);

  const handleSelectAll = () => {
    const toggleValue = !allChecked;
    setRows(rows.map((row) => ({ ...row, selected: toggleValue })));
  };

  const handleRowSelect = (index) => {
    const updatedRows = [...rows];
    updatedRows[index].selected = !updatedRows[index].selected;
    setRows(updatedRows);
  };

  const handleEditClick = (coms) => {
    setSelectedCommission(coms);
  };

  const fetchCommissionsList = async () => {
      const data = await getAllCommissionConfigurations();
      if (data.status) {
        setRows(data.data);
      } else {
        toast.error(data.message)
      }
    
  };

  const deleteCommissionConfigFun = async (coms) => {
    const confirmation = window.confirm(
      "Are you sure you want to delete this commission configuration?"
    );
    if (confirmation) {
      const data = await deleteCommissionConfig(coms._id);
      if (data.status) {
        fetchCommissionsList();
      } else {
        toast.error(data.message);
      }
    }
  };

  useEffect(() => {
    fetchCommissionsList();
  }, []);

  return (
    <>
      <section className="commission-configuration-page">
        <div className="search-input">
          <h5 className="form-title">Commission Configuration</h5>
          <button
            className="custom-btn"
            data-bs-toggle="modal"
            data-bs-target="#createCommissionConfiguration"
          >
            Create Commission Configurations
          </button>
        </div>

        <div className="table-responsive">
          <table className="table table-striped commission-configuration">
            <thead className="table-dark">
              <tr>
                {/* <th>
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={allChecked}
                      onChange={handleSelectAll}
                    />
                    <span className="checkmark"></span>
                  </label>
                </th> */}
                <th>Merchant Name</th>
                <th>Commission Type</th>
                <th>Created Date</th>
                <th>Edited Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  {/* <td>
                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        checked={row.selected}
                        onChange={() => handleRowSelect(index)}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </td> */}
                  <td>{row.merchant.fullName}</td>
                  <td>{"General"}</td>
                  <td>{moment(row.created_at).format("YYYY-MM-DD")}</td>
                  <td>{moment(row.updated_at).format("YYYY-MM-DD")}</td>
                  <td>
                    <span className="action-link">
                      {
                        <img
                          src="/images/icons/pen.svg"
                          data-bs-toggle="modal"
                          data-bs-target="#editCommissionConfiguration"
                          alt="Edit"
                          onClick={() => handleEditClick(row)}
                        />
                      }
                      {
                        <img
                          src="/images/icons/cross-circle.svg"
                          alt="Delete"
                          onClick={() => deleteCommissionConfigFun(row)}
                        />
                      }
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Create Modal */}
      <div
        className="modal fade"
        id="createCommissionConfiguration"
        tabIndex="-1"
      >
        <CreateCommission fetchCommissionsList={fetchCommissionsList}/>
      </div>
      {/* Edit Modal */}
      <div
        className="modal fade"
        id="editCommissionConfiguration"
        tabIndex="-1"
      >
        <UpdateCommissionConModal commission={selectedCommission} fetchCommissionsList={fetchCommissionsList}/>
      </div>
    </>
  );
};

export default CommissionConfigurationSection;
